import { render, staticRenderFns } from "./organization-type-description-modal.vue?vue&type=template&id=444ccef1&scoped=true"
import script from "./organization-type-description-modal.vue?vue&type=script&lang=js"
export * from "./organization-type-description-modal.vue?vue&type=script&lang=js"
import style0 from "./organization-type-description-modal.vue?vue&type=style&index=0&id=444ccef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ccef1",
  null
  
)

export default component.exports